import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

function themeButton(target: EventTarget | null): HTMLButtonElement | null {
  if (!(target instanceof Element)) return null;
  const button = target.closest('header button');
  if (!(button instanceof HTMLButtonElement)) return null;
  const label = button.getAttribute('aria-label');
  if (label !== 'Settings' && label !== 'Theme') return null;
  return button;
}

export default function HeaderThemeNotice() {
  const [open, setOpen] = useState(false);
  const [anchor, setAnchor] = useState<DOMRect | null>(null);
  const timer = useRef<number | null>(null);

  useEffect(() => {
    const show = (button: HTMLButtonElement) => {
      button.setAttribute('aria-label', 'Theme');
      setAnchor(button.getBoundingClientRect());
      setOpen(true);
      if (timer.current) window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setOpen(false), 2400);
    };

    const onClick = (event: MouseEvent) => {
      const button = themeButton(event.target);
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      show(button);
    };

    document.addEventListener('click', onClick, true);
    return () => {
      document.removeEventListener('click', onClick, true);
      if (timer.current) window.clearTimeout(timer.current);
    };
  }, []);

  if (!open || !anchor) return null;

  return createPortal(
    <div
      role="status"
      style={{
        position: 'fixed',
        top: anchor.bottom + 8,
        left: Math.max(12, anchor.right - 132),
        zIndex: 1400,
        background: '#fff',
        border: '1px solid var(--rs-neutral-200, #e4e4e4)',
        color: 'var(--rs-neutral-700, #404040)',
        fontSize: 13,
        lineHeight: 1.3,
        padding: '8px 12px',
        pointerEvents: 'none',
      }}
    >
      Coming Soon
    </div>,
    document.body,
  );
}
